import { render, staticRenderFns } from "./Flipbook.vue?vue&type=template&id=1884ea67&scoped=true"
import script from "./Flipbook.vue?vue&type=script&lang=coffee"
export * from "./Flipbook.vue?vue&type=script&lang=coffee"
import style0 from "./Flipbook.vue?vue&type=style&index=0&id=1884ea67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1884ea67",
  null
  
)

export default component.exports